import { baseApi, extractData } from "../api/axiosConfig";

export const getAllContractDataPoints = () =>
    baseApi
        .get("/contractDataPoint")
        .then(extractData);

export const addContractDataPoint = data =>
    baseApi
        .post("/contractDataPoint", data)
        .then(extractData);

export const editContractDataPoint = (id, data) =>
    baseApi
        .put(`/contractDataPoint/${id}`, data)
        .then(extractData);

export const deleteContractDataPoint = contractDataPointId =>
    baseApi
        .delete(`/contractDataPoint/${contractDataPointId}`)
        .then(extractData);

export const getNewCDP = () =>
    baseApi
        .get("/contractDataPoint/newCDP")
        .then(extractData);

export const getCDPofCBAs = () =>
    baseApi
        .get("/contractDataPoint/CDPofCBAs")
        .then(extractData);

export const getNeededCDP = () =>
    baseApi
        .get("/contractDataPoint/neededCDP")
        .then(extractData);

export const getImpededCDP = () =>
    baseApi
        .get("/contractDataPoint/impededCDP")
        .then(extractData);

export const getCompletedCDP = () =>
    baseApi
        .get("/contractDataPoint/completedCDP")
        .then(extractData);

export const get99ContractDataPoints = () =>
    baseApi
        .get("/contractDataPoint/contract99CDP")
        .then(extractData);

export const executeExpression = id =>
    baseApi
        .get("/contractDataPoint/expression", {
            params: { my_cdp_id: id }
        })
        .then(extractData);

export const deleteContractCDP = contractDataPointId =>
    baseApi
        .get("/contractDataPoint/delete", {
            params: { my_cdp_id: contractDataPointId }
        })
        .then(extractData);

export const getContractCDP = contractId =>
    baseApi
        .get("/contractDataPoint/contractCDP", {
            params: { contractId }
        })
        .then(extractData);

export const getSourcedCDP = contractId =>
    baseApi
        .get("/contract/WorkQueueCdpByAttribute", {
            params: { contract_id: contractId }
        })
        .then(extractData);

export const getSourcedParentCDP = contractId =>
    baseApi
        .get("/contract/WorkQueueParentCdp", {
            params: { contract_id: contractId }
        })
        .then(extractData);

export const getCdpPrimaryAttributes = contractId =>
    baseApi
        .get("/contractDataPoint/primaryAttributes", {
            params: { contractId }
        })
        .then(extractData);

export const getCdpHierarchy = contractId =>
    baseApi
        .get("/contractDataPoint/hierarchy", {
            params: { contractId }
        })
        .then(extractData);

export const getContractSectionCDP = contractSectionId =>
    baseApi
        .get("/contractDataPoint/getContractSectionCDP", {
            params: {
                contract_section_id: contractSectionId
            }
        })
        .then(extractData);

export const updateCDPV = (selectorCdpId, selectorDataType, selectorValue) =>
    baseApi
        .get("/contractDataPoint/updateCDPV", {
            params: {
                my_cdp_id: selectorCdpId,
                my_data_type: selectorDataType,
                my_value:
                    selectorValue === "" || selectorValue === undefined
                        ? ""
                        : selectorValue.toString()
            }
        })
        .then(extractData);

export const getCDPbyID = id =>
    baseApi
        .get("/contractDataPoint", {
            params: { id }
        })
        .then(extractData);

export const moveCDP = (selectorCdpId, moveDirection) =>
    baseApi
        .get("/contractDataPoint/moveCDP", {
            params: {
                my_cdp_id: selectorCdpId,
                move_direction: moveDirection
            }
        })
        .then(extractData);

export const updateCdpStatus = (newStatus, selectorCdpId) =>
    baseApi
        .get("/contractDataPoint/updateStatus", {
            params: {
                my_new_status: newStatus,
                my_cdp_list: selectorCdpId
            }
        })
        .then(extractData);

export const updateCdpStatusByContract = (
    newStatus,
    myContractList,
    myVersionNumber
) =>
    baseApi
        .get("/contractDataPoint/updateStatusByContract", {
            params: {
                my_new_status: newStatus,
                my_contract_list: myContractList,
                my_version_number: myVersionNumber
            }
        })
        .then(extractData);

export const updateCdpStatusByContractAndDataPoint = (
    newStatus,
    myContractList,
    myDataPointList,
    myVersionNumber
) =>
    baseApi
        .get("/contractDataPoint/updateStatusByContractAndDataPoint", {
            params: {
                my_new_status: newStatus,
                my_contract_list: myContractList,
                my_data_point_list: myDataPointList,
                my_version_number: myVersionNumber
            }
        })
        .then(extractData);

export const updateAllCdpStatusByContract = (
    newStatus,
    myContractList,
    myVersionNumber
) =>
    baseApi
        .get("/contractDataPoint/updateAllStatusByContract", {
            params: {
                my_new_status: newStatus,
                my_contract_list: myContractList,
                my_version_number: myVersionNumber
            }
        })
        .then(extractData);

export const copyCDP = (
    selectorContractDataPointId,
    selectorContractSectionId
) =>
    baseApi
        .get("/contractDataPoint/copyCDP", {
            params: {
                my_cdp_id: selectorContractDataPointId,
                my_contract_section_id: selectorContractSectionId
            }
        })
        .then(extractData);

export const refreshContractDataPoint = contractDataPointId =>
    baseApi
        .get("/contractDataPoint/refresh", {
            params: {
                my_cdp_id: contractDataPointId
            }
        })
        .then(extractData);

export const getContractDataPointVersions = contractDataPointId =>
    baseApi
        .get("/contractDataPoint/versions", {
            params: {
                my_cdp_id: contractDataPointId
            }
        })
        .then(extractData);

export const renumberContractDataPoints = contractSectionId =>
    baseApi
        .get("/contractDataPoint/renumber", {
            params: {
                contract_section_id: contractSectionId
            }
        })
        .then(extractData);

export const getCDPbyProdID = prodId =>
    baseApi
        .get("/contractDataPoint/cdpByProd", {
            params: {
                prodId
            }
        })
        .then(extractData);

export const orderCDPinCS = myCsId =>
    baseApi
        .get("/contractDataPoint/order", {
            params: {
                my_cs_id: myCsId
            }
        })
        .then(extractData);

export const getOwedStatusPie = filterAPI =>
    baseApi
        .get("/contractDataPoint/owedStatusPie", {
            params: { contract_type: filterAPI }
        })
        .then(extractData);

export const getOwedGeneratedM4mktPie = filterAPI =>
    baseApi
        .get("/contractDataPoint/owedM4mktPie", {
            params: { contract_type: filterAPI }
        })
        .then(extractData);

export const getPaymentStatusPie = filterAPI =>
    baseApi
        .get("/contractDataPoint/paymentStatusPie", {
            params: { contract_type: filterAPI }
        })
        .then(extractData);

export const getPaymentGeneratedM4mktPie = filterAPI =>
    baseApi
        .get("/contractDataPoint/paymentM4mktPie", {
            params: { contract_type: filterAPI }
        })
        .then(extractData);

export const getCdpStatsContractType = () =>
    baseApi
        .get("/contractDataPoint/cdpStatsContractType")
        .then(extractData);

export const getCdpStatsMarketGroup = () =>
    baseApi
        .get("/contractDataPoint/cdpStatsMarketGroup")
        .then(extractData);

export const getCdpStatsReleaseMarket = () =>
    baseApi
        .get("/contractDataPoint/cdpStatsReleaseMarket")
        .then(extractData);

export const getCdpStatsStandAlone = () =>
    baseApi
        .get("/contractDataPoint/cdpStatsStandAlone")
        .then(extractData);

export const getCdpStatsSeries = () =>
    baseApi
        .get("/contractDataPoint/cdpStatsSeries")
        .then(extractData);

export const getCdpStatsSeason = mySeriesId =>
    baseApi
        .get("/contractDataPoint/cdpStatsSeason", {
            params: { series_id: mySeriesId }
        })
        .then(extractData);

export const getCdpStatsEpisode = mySeasonId =>
    baseApi
        .get("/contractDataPoint/cdpStatsEpisode", {
            params: { season_id: mySeasonId }
        })
        .then(extractData);

export const getCdpStatsGuild = myProductId =>
    baseApi
        .get("/contractDataPoint/cdpStatsGuild", {
            params: { property_id: myProductId }
        })
        .then(extractData);

export const deleteCdpVersion = (
    myVersionNumber,
    myTitleId,
    myMultiSingle,
    myRecordGroup
) =>
    baseApi
        .get("/contractDataPoint/deleteCdpVersion", {
            params: {
                p_version_number: myVersionNumber,
                p_title_id: myTitleId,
                p_multi_single: myMultiSingle,
                p_record_group: myRecordGroup
            }
        })
        .then(extractData);

export const getCdpByTitle = (
    myTitleId,
    multiSingle,
    myDp1,
    myDp2,
    myDp3,
    myDp4,
    myDp5,
    myDp6,
    myDp7,
    myDp8,
    myDp9,
    myDp10
) =>
    baseApi
        .get("/contractDataPoint/byTitle", {
            params: {
                my_title_id: myTitleId,
                my_multi_single: multiSingle,
                my_dp1: myDp1,
                my_dp2: myDp2,
                my_dp3: myDp3,
                my_dp4: myDp4,
                my_dp5: myDp5,
                my_dp6: myDp6,
                my_dp7: myDp7,
                my_dp8: myDp8,
                my_dp9: myDp9,
                my_dp10: myDp10
            }
        })
        .then(extractData);


export const getAccountHierarchy = myContractId =>
    baseApi
        .get("/contractDataPoint/accountHierarchy", {
            params: { my_contract_id:  myContractId }
        })
        .then(extractData);


export const getAccountChildren = mySectionId =>
    baseApi
        .get("/contractDataPoint/accountChildren", {
            params: { my_section_id:  mySectionId }
        })
        .then(extractData);



// import axios from "axios";
//
//
// const BASE_URL = import.meta.env.VITE_BACKEND_URL;
//
// export const getAllContractDataPoints = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export   const addContractDataPoint = abcd =>
//     axios.post(`${BASE_URL}/api/contramatic/contractDataPoint`, abcd, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log("here's my abcd");
//             console.log({abcd});
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// // export const editContractDataPoint = (selectorContractDataPointId, abcd) =>
// export const editContractDataPoint = (id, abcd) =>
//     axios.put(`${BASE_URL}/api/contramatic/contractDataPoint/${id}`, abcd, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//
//         .then(function (response) {
//             // console.log("here's my id");
//             // console.log({selectorContractDataPointId});
//             console.log("here's my abcd");
//             console.log({abcd});
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log("here's my id");
//                 // console.log({selectorContractDataPointId});
//                 console.log("here's my abcd error 1");
//                 console.log({abcd});
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log("here's my id");
//                 // console.log({selectorContractDataPointId});
//                 console.log("here's my abcd error 2");
//                 console.log({abcd});
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log("here's my id");
//                 // console.log({selectorContractDataPointId});
//                 console.log("here's my abcd error 3");
//                 console.log({abcd});
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// //https://www.javatpoint.com/react-axios-delete-request-example except that it shows the wrong kinds of quotes - not backquotes
// export const deleteContractDataPoint = selectorContractDataPointId =>
//     axios.delete(`${BASE_URL}/api/contramatic/contractDataPoint/${selectorContractDataPointId}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getNewCDP = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/newCDP`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
// export const getCDPofCBAs = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/CDPofCBAs`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getNeededCDP = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/neededCDP`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getImpededCDP = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/impededCDP`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCompletedCDP = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/completedCDP`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const get99ContractDataPoints = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/contract99CDP`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
// export const executeExpression = (id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cdp_id: id}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const deleteContractCDP = (contractDataPointId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/delete`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cdp_id: contractDataPointId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getContractCDP = (contractId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/contractCDP`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {contractId: contractId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getSourcedCDP = (contractId) =>
//     // axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/sourcedCDP`,
//         axios.get(`${BASE_URL}/api/contramatic/contract/WorkQueueCdpByAttribute`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {contract_id: contractId}
//             // params: {contractId: contractId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getSourcedParentCDP = (contractId) =>
//     // axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/sourcedCDP`,
//     axios.get(`${BASE_URL}/api/contramatic/contract/WorkQueueParentCdp`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {contract_id: contractId}
//             // params: {contractId: contractId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// //
// // export const getCdpPrimaryAttributes = (contractId) =>
//
// export const getCdpPrimaryAttributes = (contractId) =>
//     // axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/sourcedCDP`,
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/primaryAttributes`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {contractId: contractId}
//             // params: {contractId: contractId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCdpHierarchy = (contractId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/hierarchy`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {contractId: contractId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// // export const getContractSectionCDP = (contractSectionId) =>
// //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/contractSectionCDP`,
// //         {
// //             params: {contractSectionId: contractSectionId}
// export const getContractSectionCDP = (contractSectionId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/getContractSectionCDP`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {contract_section_id: contractSectionId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const updateCDPV = (selectorCdpId, selectorDataType, selectorValue) =>
// // export const updateCDPV = (selectorCdpId, selectorDataType, data) =>
// // {
// //     console.log("value being submitted for update: ", {selectorValue});
//
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/updateCDPV`
//         ,
//         {
//             // params: {my_cdp_id: data.cdpId
//             //     ,
//             //     my_data_type: data.dataType,
//             //     my_value: data.value.toString()
//             // }
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 my_cdp_id: selectorCdpId,
//                 my_data_type: selectorDataType,
//                 // my_value: selectorValue.toString()
//                 my_value: selectorValue === '' ? '' : selectorValue === undefined ? '' : selectorValue.toString()
//                 // my_value: data.value2.toString()
//             }
//         }
//     )
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         })
// // }
// ;
//
//
// export const getCDPbyID = (id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint`,
// {
//     headers: {
//         'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//     },
//     params: {id: id}
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const moveCDP = (selectorCdpId, moveDirection) =>
// // export const updateCDPV = (selectorCdpId, selectorDataType, data) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/moveCDP`
//         ,
//         {
//             // params: {my_cdp_id: data.cdpId
//             //     ,
//             //     my_data_type: data.dataType,
//             //     my_value: data.value.toString()
//             // }
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cdp_id: selectorCdpId,
//                 move_direction: moveDirection
//                 // my_value: data.value2.toString()
//             }
//         }
//     )
//
//
// export const updateCdpStatus = (newStatus, selectorCdpId) =>
// //     console.log("client cdp list");
// // console.log(selectorCdpId);
// // export const updateCDPV = (selectorCdpId, selectorDataType, data) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/updateStatus`
//         ,
//         {
//             // params: {my_cdp_id: data.cdpId
//             //     ,
//             //     my_data_type: data.dataType,
//             //     my_value: data.value.toString()
//             // }
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 my_new_status: newStatus,
//                 // my_cdp_list: selectorCdpId
//                 my_cdp_list: selectorCdpId
//                 // my_cdp_list: "2004144,2004145"
//                 // my_value: data.value2.toString()
//             },
//             // paramsSerializer: my_cdp_list => {return qs.stringify(my_cdp_list)}
//
//         }
//
//     )
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//             console.log("client cdp list");
//             console.log(selectorCdpId);
//             // console.log(qs.stringify(selectorCdpId));
//         });
//
// export const updateCdpStatusByContract = (newStatus, myContractList, myVersionNumber) =>
// //     console.log("client cdp list");
// // console.log(selectorCdpId);
// // export const updateCDPV = (selectorCdpId, selectorDataType, data) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/updateStatusByContract`
//         ,
//         {
//
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 my_new_status: newStatus,
//                 my_contract_list: myContractList,
//                 my_version_number: myVersionNumber
//             },
//
//         }
//
//     )
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//             // console.log("client cdp list");
//             // console.log(selectorCdpId);
//             // console.log(qs.stringify(selectorCdpId));
//         });


//
// export const getCDPbyProdID = (prodId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/cdpByProd`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {prodId: prodId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const orderCDPinCS = (my_cs_id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/order`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cs_id: my_cs_id}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });

//
// export const getOwedStatusPie = (filterAPI) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/owedStatusPie`,         {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         },
//         params: {contract_type: filterAPI}
//     })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getOwedGeneratedM4mktPie = (filterAPI) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/owedM4mktPie`,         {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         },
//         params: {contract_type: filterAPI}
//     })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getPaymentStatusPie = (filterAPI) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/paymentStatusPie`,         {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         },
//         params: {contract_type: filterAPI}
//     })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getPaymentGeneratedM4mktPie = (filterAPI) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/paymentM4mktPie`,         {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         },
//         params: {contract_type: filterAPI}
//     })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
// export const getCdpStatsContractType = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/cdpStatsContractType`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log("Error retrieving data for Stats");
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getCdpStatsMarketGroup = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/cdpStatsMarketGroup`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log("Error retrieving data for Stats");
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCdpStatsReleaseMarket = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/cdpStatsReleaseMarket`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log("Error retrieving data for Stats");
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCdpStatsStandAlone = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/cdpStatsStandAlone`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log("Error retrieving data for Stats");
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCdpStatsSeries = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/cdpStatsSeries`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log("Error retrieving data for Stats");
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
// export const getCdpStatsSeason = (mySeriesId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/cdpStatsSeason`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {series_id: mySeriesId
//             }
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCdpStatsEpisode = (mySeasonId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/cdpStatsEpisode`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {season_id: mySeasonId
//             }
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCdpStatsGuild = (myProductId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/cdpStatsGuild`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {property_id: myProductId
//             }
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const deleteCdpVersion = (myVersionNumber, myTitleId, myMultiSingle, myRecordGroup) =>
// // export const updateCDPV = (selectorCdpId, selectorDataType, data) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/deleteCdpVersion`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 p_version_number: myVersionNumber,
//                 p_title_id: myTitleId,
//                 p_multi_single: myMultiSingle,
//                 p_record_group: myRecordGroup
//             }
//
//         }
//     );
//
//
// export const getCdpByTitle = (myTitleId, multiSingle, myDp1, myDp2, myDp3, myDp4, myDp5, myDp6, myDp7, myDp8, myDp9, myDp10) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/byTitle`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_title_id: myTitleId,
//                 my_multi_single: multiSingle,
//                 my_dp1: myDp1,
//                 my_dp2: myDp2,
//                 my_dp3: myDp3,
//                 my_dp4: myDp4,
//                 my_dp5: myDp5,
//                 my_dp6: myDp6,
//                 my_dp7: myDp7,
//                 my_dp8: myDp8,
//                 my_dp9: myDp9,
//                 my_dp10: myDp10
//             }
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });